import { createContext, useContext } from "react";

/** Lets a page renumber shared tool sections (the Workbook reuses some Resource Pack sections). */
export const NumberCtx = createContext(null);
export const useToolNumber = (id, fallback) => useContext(NumberCtx)?.[id] ?? fallback;
